export const getValueFromLocalStorage = (key: string): any => {
  try {
    const value = window.localStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const setValueInLocalStorage = (key: string, value: any) => {
  if (value !== null) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
};

export const deleteValueFromLocalStorage = (key: string) => {
  window.localStorage.removeItem(key);
};

export const clearStorage = () => {
  window.localStorage.clear();
};
